import PropTypes from "prop-types"

import Button from "components/ui/button"

const SampleCertLink = ({ stoneType }) => {
  const certImage = stoneType === "04LABDIAM" ? "GIA-lab-cert" : "GIA-cert"
  return (
    <Button asChild text underline variant="secondary">
      <a
        href={`${sl.config.jewlr_asset_url}images/product/diamond/${certImage}.jpg`}
        rel="noreferrer"
        target="_blank"
      >
        View Sample Certificate
      </a>
    </Button>
  )
}

SampleCertLink.propTypes = {
  stoneType: PropTypes.string,
}

export default SampleCertLink
